export const OBJECT_OWNER = 'OBJECT_OWNER';
export const OBJECT_PROPERTY = 'OBJECT_PROPERTY';
export const CUSTOM = 'CUSTOM';
export const NONE = 'NONE';